<template>

    <Page>

        <ImageAndText 
            animation="zoom"
            src="/WorkOrders/eligibility.jpg"
            border
            image-class="rounded-xl"
            floor-shadow>

            <h2 class="mb-4">Customer Eligibility</h2>
            <ul class="mt-3 list-disc pl-6 font-normal text-white/80">
                <li>Vehicles must meet specific road-worthiness and age requirements</li>
                <li>Vehicle owner must be over 18 years of age</li>
                <li>Contracts are non-transferable between vehicles but may transfer to a private buyer</li>
                <li>Non-eligible uses: rideshare, courier services, farming, motorsport</li>
                <li>Other ineligible vehicles:</li>
                <ul class="ml-6 mt-1 list-decimal list-inside font-normal text-white/80">
                    <li>Fully electric vehicles</li>
                    <li>Motorcycles, scooters, quad bikes, tricycles, mopeds</li>
                    <li>Kit cars</li>
                    <li>Trucks, buses, coaches, stretched limousines</li>
                    <li>Motorhomes &amp; campervans</li>
                </ul>
            </ul>

        </ImageAndText>

    </Page>

</template>